module.exports = __webpack_public_path__ + "img/5.0101a609.png";